import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
import api from "./api.js";

export default async function returnReasonPost(jobOrderId, reason) {
  const Authorization = "bearer " + localStorage.getItem("token");
  //   alert(jobOrderId);
  const resp = await fetch(`${API_URL}rest/V1/rider/returnOrder`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept, Authorization },
    body: JSON.stringify({ jobOrderId, reason }),
  })
    .then(function (response) {
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      window.location.reload();
      return response.json();
    })
    .then(function (data) {
      // api.callShippingJobs(component,trip_id);

      console.log("returnReasonPostApi", data);
      return data;
      //   alert(JSON.stringify(data));
    });
  return resp;
}



// WEBPACK FOOTER //
// ./src/utility/api/returnReasonPost.js